<template>
  <el-dialog :close-on-click-modal="false" :visible="visible" append-to-body title="门诊挂号" @close="cancel" width="76rem" top="4vh">
    <el-main style="padding: 0 3rem 0 3rem; margin-top: -1rem">
      <patient-selector v-model="patient" :type.sync="opType" @ok="queryPatientRegs" @cancel="clearRegs" ref="refPatient" />
      <el-card shadow="never">
        <el-row type="flex">
          <el-tabs tab-position="left" v-model="activeGrp">
            <el-tab-pane v-for="grp in grps" :key="grp" :name="grp" :label="grp" class="left" />
          </el-tabs>
          <regno ref="regno" :targets="targets" :grp="activeGrp" :patient="patient" :opType="opType" @locked="openPay" />
        </el-row>
      </el-card>
      <p class="left">已挂号:</p>
      <el-skeleton v-if="meta.loading" animated :rows="6" style="height:300px;text-align: left;" />
      <el-table v-else :data="lockedRegs" stripe height="300"  :empty-text="!!patient ? '患者还没有挂号!' : '请先选择患者!'">
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="warning" icon="el-icon-money" circle size="small" title="支付取号" @click="openPay(row)" :disabled="row.state != '预约'" plain></el-button>
            <el-popconfirm title="确认取消预约吗?" @confirm="del(row)">
              <el-button slot="reference" type="danger" icon="el-icon-delete" circle size="small" class="left-pad" title="取消预约" :disabled="row.state != '预约'" plain></el-button>
            </el-popconfirm>
            <!-- <el-button
              type="primary"
              icon="el-icon-printer"
              circle
              size="small"
              title="补打发票"
              :disabled="row.state == '预约'"
              class="left-pad"
              plain
            ></el-button>
            <el-button
              type="info"
              icon="el-icon-printer"
              circle
              size="small"
              title="打印挂号凭证"
              :disabled="row.state == '预约'"
              plain
              @click="printVoucher(row)"
            ></el-button>  -->
          </template>
        </el-table-column>

        <el-table-column label="状态" prop="state" align="cneter" width="65">
          <template slot-scope="{ row }">
            <el-tag v-if="row.state == '就诊'" size="small" type="danger" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else-if="row.state == '报到'" size="small" type="success" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else-if="row.state == '取号'" size="small" type="warning" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else size="small" type="info" effect="plain">{{ row.state }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付" prop="paymentState" align="center" width="65">
          <template slot-scope="{ row }">
            <el-tag v-if="!row.paymentState || Enum.PaymentState.未支付 == row.paymentState" type="danger" size="small" effect="plain">{{ Enum.PaymentState.未支付 }} </el-tag>
            <el-tag v-else type="success" size="small" effect="plain">{{ row.paymentState }} </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="paymentState" align="center" width="65">
          <template slot-scope="{ row }">
            <el-tag v-if="Enum.OpType.医保工伤 == row.opType" size="small" effect="plain" type="danger">{{ row.opType }} </el-tag>
            <el-tag v-else-if="Enum.OpType.医保 == row.opType" size="small" effect="plain" type="warning">{{ row.opType }} </el-tag>
            <el-tag v-else size="small" effect="plain" type="success">{{ row.opType }} </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="号别" prop="regType" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.regType | dictText("RegType") }}
          </template>
        </el-table-column>
        <el-table-column label="科室医师" prop="deptCode" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.deptCode | dictText("Dept") }}<span v-if="row.doctorName"><br />{{ row.doctorName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="date" align="center" width="120">
          <template slot-scope="{ row }">
            <span type="info" effect="dark" size="mini">{{ row.date | fmtDate }}</span
            ><br />
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="periodType" width="80" align="center">
          <template slot-scope="{ row }">
            {{ row.periodType }}<br/>
            <span v-if="row.seqNo">No.{{ row.seqNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="费用" prop="price" align="right" width="80">
          <template slot-scope="{ row }"> ￥{{ row.price | fmtFloat(2) }} </template>
        </el-table-column>
        <el-table-column label="预约渠道" prop="appointmentChannelCode" align="center">
          <template slot-scope="{ row }">
            {{ row.appointmentChannelCode | dictText("AppointmentChannel") }}
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <!-- <patient-editor v-if="editingPatient" title="患者" v-model="editingPatient" :visible.sync="meta.showEditor" @saved="patientSaved"></patient-editor> -->
    <pay-dialog :opType="opType" :feeReceipt="{ regs: [reg], enterprise: enterprise }" :visible.sync="meta.showPay" @paid="paid" @cancel="cancelPay"></pay-dialog>
  </el-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "vuex";
  import { getLodop } from "@/common/LodopFuncs";
  import moment from "moment";
  import printMixin from "../_com/printMixin";
  export default {
    mixins: [printMixin],
    components: {
      "patient-selector": () => import("@/components/_com/selectorPatient"),
      regno: () => import("./_regno"),
      "pay-dialog": () => import("@/components/fee/pay"),
    },
    props: {
      visible: Boolean,
      idCard: { // 来自列表的身份证信息
        type: Object,
        default: null
      }
    },
    data() {
      return {
        meta: {
          // showEditor: false,
          loading: false,
          showPay: false,
          searching: false,
          // form: {
          //   idType: null,
          //   idNo: null,
          // },
        },
        targets: [],
        opType: "自费",
        patient: null,
        // editingPatient: null,
        lockedRegs: [],
        activeGrp: null,
        reg: null,
        enterprise: null
        // payment: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user"]),
      // 分组
      grps() {
        return this.targets.reduce((grps, next) => {
          if (!grps.find((grp) => grp == next.grp)) {
            grps.push(next.grp);
          }
          return grps;
        }, []);
      },
    },
    mounted() {
      this.queryTargets();
      setTimeout(() => { // 一定是异步，不然，获取不了$refs.refPatient
        if (this.idCard && this.$refs.refPatient) {
          // 在列表页面点击“身份证读卡”后，直接调用
          this.$refs.refPatient.query(this.idCard, false);
        }
      }, 500);
    },
    methods: {
      // 获取所有可用号别
      queryTargets() {
        api
          .queryValidRegType()
          .then((targets) => {
            this.genGrp(targets);
          })
          .catch((err) => {
            this.$message.error(err);
            this.genGrp([]);
          });
      },
      // 补充急诊分组，格式化显示文本
      genGrp(targets) {
        targets.forEach((t) => {
          t.grp = t.name;
          if (t.rotaType == this.Enum.OpRotaType.专家) {
            t.text = `${t.deptName}: ${t.doctorName}`;
          } else if (t.rotaType == this.Enum.OpRotaType.科室) {
            t.text = t.deptName;
          }
        });
        targets.push(
          ...this.dict.RegType.filter((t) => t.rotaType == this.Enum.OpRotaType.急诊).map((t) => ({
            grp: "急诊",
            deptCode: t.deptCode,
            regType: t.code,
            rotaType: t.rotaType,
            text: t.name,
            targetId: t.code,
          }))
        );
        this.targets = targets;
        this.activeGrp = this.grps[0];
      },
      openPay(row) {
        if (!row) {
          return;
        }
        if (row.opType && row.opType != this.opType) {
          this.$message.warning("就诊类型不同，无法支付！");
          return;
        }
        if (row.paymentState && row.paymentState != this.Enum.PaymentState.未支付) {
          return;
        }
        this.reg = row;
        if (!this.reg.cardNo && this.patient.cardNo) {
          this.reg.cardType = this.patient.cardType;
          this.reg.cardNo = this.patient.cardNo;
        }
        this.reg.opType = this.opType;
        this.enterprise = this.patient.enterprise;
        this.meta.showPay = true;
      },
      cancelPay() {
        let _this = this;
        if (this.$utils.fmtDate(this.reg.appointmentDate) == this.$utils.fmtDate(new Date())) {
          // 如果是当天挂号时锁的号，就自动取消锁号；如果是之前预约的号，就不要自动取消；
          api.delAppointment(this.reg.id).then((res) => {
            _this.$message.success("已取消锁号！");
            _this.reg = null;
            _this.queryPatientRegs();
            _this.$refs.regno.refreshRegs();
          });
        }
      },
      async queryPatientRegs() {
        this.meta.loading = true;
        let date = await this.$utils.getServerTime();
        let endDate = this.$utils.fmtDate(moment(date).add(6, 'days'));
        try {
          let res = await api.queryReg({
            pageIndex: 1,
            pageSize: 99,
            startDate: date.substring(0, 10),
            endDate: endDate,
            patientId: this.patient.id,
            // state: "预约"
          });
          this.lockedRegs = res.items;
        } catch (err) {
          console.log(err);
        } finally {
          this.meta.loading = false;
        }
      },
      injuriesChange(val) {
        console.log(val);
      },
      del(regno) {
        api.delAppointment(regno.id).then((res) => {
          this.$message.success("已取消锁号！");
          this.queryPatientRegs();
          this.$refs.regno.refreshRegs();
        });
      },
      cancel() {
        this.$emit("close");
        this.$emit("update:visible", false);
      },
      paid(payment) {
        // 取号
        api.takeRegNo(this.reg.id).then((res) => {
          this.queryPatientRegs();
        }).finally(() => {
          this.printReceipt(this.reg, payment); // 来源 printMixin.js
        });
      },
      clearRegs() {
        this.lockedRegs = [];
      },
    },
  };
</script>

<style scoped></style>
